/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OwnerApproveProjectItemSampleCommand } from '../../models/owner-approve-project-item-sample-command';
import { OwnerApproveProjectItemSampleCommandResult } from '../../models/owner-approve-project-item-sample-command-result';

export interface ApiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Params {
  
    /**
     * The command to approve or reject a project item Sample.
     */
    body?: OwnerApproveProjectItemSampleCommand
}

export function apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<OwnerApproveProjectItemSampleCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OwnerApproveProjectItemSampleCommandResult>;
    })
  );
}

apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch.PATH = '/api/ProjectItemSamples/OwnerApproveOrRejectProjectItemSample';
